<mat-toolbar color="accent">
	<mat-toolbar-row>
		<span>
			{{ subTitle }}
		</span>
		<span class="spacer"></span>
		<button mat-raised-button type="button" aria-label="Edit" (click)="handleBack()">
			<mat-icon>chevron_left</mat-icon>
		</button>
		<button mat-raised-button type="button" aria-label="Edit" (click)="handleEdit()">
			<mat-icon>edit</mat-icon>
		</button>
	</mat-toolbar-row>
</mat-toolbar>

<div class="field-container" *ngIf="isLoaded">
	<div class="field-item field-full field-sm-half">
		<label>First Name</label>
		<span>{{person.first_name}}</span>
	</div>
	<div class="field-item field-full field-sm-half">
		<label>Last Name</label>
		<span>{{person.last_name}}</span>
	</div>
	<div class="field-item field-full field-sm-half">
		<label>Title</label>
		<span>{{person.physician.title }}</span>
	</div>
	<div class="field-item field-full field-sm-half">
		<label>Preferred Name</label>
		<span>{{person.preferred_name }}</span>
	</div>
	<div class="field-item field-full field-sm-half">
		<label>Email</label>
		<span>{{person.user.email}}</span>
	</div>
	<div class="field-item field-full field-sm-half">
		<label>Phone</label>
		<span>{{person.phone}}</span>
	</div>
	<div class="field-item field-full field-sm-half">
		<label>Username</label>
		<span>{{person.user.username}}</span>
	</div>
	<div class="field-item field-full field-lg-quarter">
		<label>Is Active?</label>
		<span>{{person.user.is_active}}</span>
	</div>
	<div class="field-item field-full field-lg-quarter">
		<label>Password Change Required</label>
		<span>{{(person.user.has_password_change ? 'Yes' : 'No' )}}</span>
	</div>
	<div class="field-item field-full">
		<label>User Role(s)</label>
		<span>
			<ng-container *ngFor="let role of person.user.roles">
				<span class="role-container">{{ role.role_name }}</span>
			</ng-container>
		</span>
	</div>
</div>